import { FC } from 'react'

import { LogoProps } from '@assets/logo/types'

export const TMGenericLogo: FC<LogoProps> = ({ className }) => (
  <svg
    className={className}
    width='157'
    height='32'
    viewBox='0 0 157 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.3516 22.3515H12.3234C11.7098 22.3515 11.1473 22.0277 10.8405 21.4993L7.95994 16.5052C7.65313 15.9768 7.65313 15.3291 7.95994 14.8007L10.8405 9.80654C11.1473 9.27815 11.7098 8.95429 12.3234 8.95429H17.3516L21.3401 2C21.2549 2 21.1697 2 21.0845 2H9.34057C8.0963 2 6.95429 2.66475 6.34068 3.73857L0.460211 13.8973C-0.153404 14.9711 -0.153404 16.3006 0.460211 17.3744L6.32363 27.5332C6.93725 28.607 8.0963 29.2717 9.32353 29.2717H21.0674C21.1526 29.2717 21.2379 29.2717 21.3231 29.2547L17.3346 22.3515H17.3516Z'
      fill='#FF0044'
    />
    <path
      d='M29.9478 13.8974L24.0844 3.73867C24.0332 3.67049 23.9821 3.60231 23.948 3.51709L19.9595 10.4202L22.4651 14.7667C22.7719 15.2951 22.7719 15.9428 22.4651 16.4712L19.9595 20.8176L23.948 27.7208C23.9991 27.6526 24.0503 27.5844 24.0844 27.4992L29.9478 17.3405C30.5614 16.2666 30.5614 14.9371 29.9478 13.8633V13.8974Z'
      fill='#28F981'
    />
    <path
      d='M46.3108 23.9539H42.3735V9.84079H37.0555V6.5H51.6459V9.84079H46.3108V23.9539Z'
      fill='var(--text-white)'
    />
    <path d='M58.174 23.9539H54.2367V6.5H58.174V23.9539Z' fill='var(--text-white)' />
    <path
      d='M70.4293 24.2266C67.8044 24.2266 65.6226 23.3744 63.8841 21.6529C62.1455 19.9313 61.2762 17.7837 61.2762 15.1758C61.2762 12.568 62.1625 10.5226 63.9352 8.80107C65.7079 7.07954 67.9237 6.22729 70.5827 6.22729C73.2417 6.22729 75.4745 7.19885 77.4688 9.14196L75.1677 11.9544C73.7701 10.4203 72.2531 9.65331 70.6338 9.65331C69.0146 9.65331 67.9066 10.1476 66.8669 11.1703C65.8442 12.1759 65.3158 13.4884 65.3158 15.1247C65.3158 16.761 65.4181 16.5053 65.6397 17.153C65.8613 17.8007 66.1851 18.3973 66.6453 18.9257C67.0885 19.4541 67.651 19.8632 68.3157 20.17C68.9805 20.4768 69.7475 20.6302 70.6338 20.6302C72.2019 20.6302 73.7019 19.9484 75.1677 18.5678L77.4858 21.0904C75.3041 23.1869 72.9519 24.2266 70.4293 24.2266Z'
      fill='var(--text-white)'
    />
    <path
      d='M96.4738 23.9539H91.7524L86.7241 16.7951L84.2356 19.5563V23.9369H80.2982V6.5H84.2356V14.6304L91.4626 6.5H96.0477L89.4684 13.7611L96.4738 23.9539Z'
      fill='var(--text-white)'
    />
    <path
      d='M118.717 23.9539H115.172V12.1589L110.212 22.1812H107.672L102.678 12.1589V23.9539H99.1328V6.5H103.513L108.951 17.2212L114.337 6.5H118.7V23.9539H118.717Z'
      fill='var(--text-white)'
    />
    <path d='M127.001 23.9539H123.064V6.5H127.001V23.9539Z' fill='var(--text-white)' />
    <path
      d='M142.751 23.9539H131.33V6.5H135.268V20.5109H142.751V23.9539Z'
      fill='var(--text-white)'
    />
    <path d='M157 23.9539H145.58V6.5H149.517V20.5109H157V23.9539Z' fill='var(--text-white)' />
  </svg>
)
